import loadable from "@loadable/component";

export const ExplanationPage = loadable(() => import("./ExplanationPage"), {
  resolveComponent: mod => mod.ExplanationPage,
});

export * from "./types";
